import { useState } from 'react';

import { useQueryListUnassignedStation } from './useQuery/useQueryListUnassignedStation';

export const useSearchUnassignedStation = () => {
  const [search, setSearch] = useState('');

  const getUnassignedStationQuery = useQueryListUnassignedStation({
    search: search,
    page: 0,
    size: 20,
  });

  const onSearchUnassignedStation = (searchString: string) => {
    setSearch(searchString);
  };

  return {
    getUnassignedStationQuery,
    onSearchUnassignedStation,
  };
};
